import { render } from "./seller-details.vue?vue&type=template&id=4010cfe0"
import script from "./seller-details.vue?vue&type=script&lang=js"
export * from "./seller-details.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__